import { useState } from 'react'

const csrf = () => document.querySelector('meta[name="csrf-token"]')?.content || ''

// フォロー/フォロー中をその場でトグル（リロードなし）。
// variant: "sm"（ランキング内の小ボタン）/ "lg"（プロフィールの大ボタン）
export default function FollowButton({ dataset }) {
  const userId = dataset.userId
  const variant = dataset.variant || 'sm'
  const [following, setFollowing] = useState(dataset.following === 'true')
  const [busy, setBusy] = useState(false)

  function toggle() {
    if (busy) return
    setBusy(true)
    fetch(`/users/${userId}/follow`, {
      method: following ? 'DELETE' : 'POST',
      headers: { 'X-CSRF-Token': csrf(), Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((d) => setFollowing(!!d.following))
      .catch(() => {})
      .finally(() => setBusy(false))
  }

  let cls
  if (variant === 'lg') {
    cls = following ? 'dj-btn dj-btn--ghost dj-btn--sm' : 'dj-btn dj-btn--primary dj-btn--sm'
  } else {
    cls = following ? 'dj-followbtn dj-followbtn--on' : 'dj-followbtn'
  }

  return (
    <button type="button" className={cls} onClick={toggle} disabled={busy}>
      {following ? 'フォロー中' : 'フォロー'}
    </button>
  )
}
